import { render } from "./route-view.vue?vue&type=template&id=7bde956e"
const script = {}
script.render = render

export default script